class FacetFiltersForm extends HTMLElement {
  static get observedAttributes() {
    return ["selected-index"];
  }
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);
    this.querySelector("form").addEventListener(
      "input",
      this.debouncedOnSubmit.bind(this)
    );
  }
  get selectedIndex() {
    return parseInt(this.getAttribute("selected-index")) || 0;
  }
  set selectedIndex(index) {
    this.setAttribute("selected-index", index);
  }
  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const container = document.getElementsByClassName("thb-filter-count");
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");
    const countContainerDesktop = document.getElementById("ProductCountDesktop");

    for (var item of container) {
      item.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      if (FacetFiltersForm.filterData.some(filterDataUrl)) {
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
      } else {
        FacetFiltersForm.renderSectionFromFetch(url, event);
      }
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        // console.log("Server response:", responseText);
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          {
            html,
            url,
          },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;

    // Dispatch filter:changed event
    document.dispatchEvent(new CustomEvent("filter:changed"));

    ScrollTrigger.batch(
      ".animations-true .product-card .product-featured-image-link, .animations-true .products .gallery--item figure",
      {
        start: "top 90%",
        onEnter: (elements, triggers) => {
          gsap.to(elements, {
            scale: 1,
            opacity: 1,
            stagger: 0.15,
            ease: window.theme.settings.animation_easing,
          });
        },
      }
    );

    document.getElementById("Facets-Toggle-Fixed")?.setElements();

    document.dispatchEvent(new CustomEvent("gtm:product-grid-updated"));
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCountDesktop").innerHTML;

    const containerDesktop = document.getElementById("ProductCountDesktop");

    if (containerDesktop) {
      containerDesktop.innerHTML = count;
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#FacetsModal-inner .facets-popup-modal--tab"
    );
    const matchesIndex = (element) => {
      const jsFilter = event
        ? event.target.closest(".facets-popup-modal--tab")
        : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element)
    );

    facetsToRender.forEach((element) => {
      document.querySelector(
        `.facets-popup-modal--tab[data-index="${element.dataset.index}"]`
      ).innerHTML = element.innerHTML;
    });
    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (typeof SelectWidth !== "undefined") {
      new SelectWidth();
    }
  }
  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [".active-facets"];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }
  static renderAdditionalElements(html) {
    const facetButtons = [
      "#Facets-Toggle",
      "#Facets-Toggle-Fixed",
      "#FacetFiltersForm-buttons",
      ".thb-filter-sort-count--bar",
      ".thb-filter-sort-count--modal",
    ];

    facetButtons.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });
  }

  static updateURLHash(searchParams) {
    history.pushState(
      {
        searchParams,
      },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest("form"));
    const searchParams = new URLSearchParams(formData);

    if (searchParams.get("filter.v.price.gte") === "0.00") {
      searchParams.delete("filter.v.price.gte");
    }
    if (document.querySelector(".price_slider")) {
      if (
        searchParams.get("filter.v.price.lte") ===
        parseFloat(document.querySelector(".price_slider").dataset.max).toFixed(2)
      ) {
        searchParams.delete("filter.v.price.lte");
      }
    }
    const selectedSize = searchParams.get("filter.v.option.size");

    if (selectedSize) {
      // Check if the selected size already exists
      const existingSizes = searchParams.getAll("filter.v.option.size");
      if (!existingSizes.includes(selectedSize)) {
        searchParams.append("filter.v.option.size", selectedSize); // Back up in case the size option param wasn't added
      }
    }
    FacetFiltersForm.renderPage(searchParams.toString(), event);

    this.scrollToFacetsWrapper(event);

    const sortFilterForms = document.querySelectorAll("facet-filters-form form");

    this.filterAndSortDataLayer(event, searchParams, sortFilterForms);
  }

  filterAndSortDataLayer(event, searchParams, sortFilterForms) {
    const dataLayer = window.dataLayer || [];

    const eventTargetId = event?.target?.id || "";
    const sortBy = searchParams.get("sort_by");
    if (
      sortBy &&
      this.sortBy !== sortBy &&
      eventTargetId.toLowerCase().includes("sortby")
    ) {
      this.sortBy = sortBy;
      dataLayer.push({
        event: "sort_use",
        sort_option: sortBy,
      });
      return;
    }

    let selectedInput = event?.detail?.selectedInput || event?.target || null;

    if (!selectedInput) return;
    if (selectedInput.type === "checkbox" && !selectedInput.checked) {
      return;
    }

    const isPriceFilter = selectedInput.name.includes("price");
    const detailsElement = selectedInput.closest("facet-toggle-button");
    let filterGroup, filterOption;

    if (detailsElement) {
      filterOption = isPriceFilter
        ? event?.detail?.value
        : selectedInput.parentElement
            .querySelector("label")
            .textContent.replace(/\s+/g, " ")
            .trim();

      filterGroup = detailsElement
        .querySelector(".accordion-facets--toggle")
        .textContent.trim();

      if (isPriceFilter) {
        if (selectedInput.id.includes("GTE")) {
          filterGroup = "Price_Min";
        } else if (selectedInput.id.includes("LTE")) {
          filterGroup = "Price_Max";
        }
      }
    } else {
      filterOption = selectedInput.parentElement
        .querySelector("label")
        .textContent.replace(/\s+/g, " ")
        .trim();
      filterGroup = selectedInput.name || "unknown_filter";
    }

    dataLayer.push({
      event: "filter_use",
      filter_group: filterGroup,
      filter_option: filterOption,
    });
  }

  scrollToFacetsWrapper(event) {
    const header = document.querySelector("#header"),
      megaMenu = document.querySelector(".full-mega-menu"),
      facetsWrapper = document.querySelector(".collection-container");

    if (!event.target.closest(".thb-filter-availability")) {
      window.scrollTo({
        top: facetsWrapper.offsetTop - header.offsetHeight - megaMenu.offsetHeight,
        behavior: "smooth",
      });
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf("?") + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) => {
      element.addEventListener("change", this.onRangeChange.bind(this));
      element.addEventListener("keydown", this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern =
      /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("data-max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("data-min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("data-min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("data-max", maxInput.getAttribute("data-max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("data-min"));
    const max = Number(input.getAttribute("data-max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("a").forEach((item) => {
      item.addEventListener("click", (event) => {
        event.preventDefault();
        const form = this.closest("facet-filters-form");
        form.onActiveFilterClick(event);
      });
    });
  }
}

customElements.define("facet-remove", FacetRemove);

/**
 *  @class
 *  @function PriceSlider
 */
class PriceSlider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    let slider = this.querySelector(".price_slider"),
      amounts = this.querySelector(".price_slider_amount"),
      args = {
        start: [
          parseFloat(slider.dataset.minValue || 0),
          parseFloat(slider.dataset.maxValue || slider.dataset.max),
        ],
        connect: true,
        step: 10,
        direction: document.dir,
        handleAttributes: [{"aria-label": "lower"}, {"aria-label": "upper"}],
        range: {
          min: 0,
          max: parseFloat(slider.dataset.max),
        },
      },
      event = new CustomEvent("input"),
      form =
        this.closest("facet-filters-form") ||
        document.querySelector("facet-filters-form");

    if (slider.classList.contains("noUi-target")) {
      slider.noUiSlider.destroy();
    }
    noUiSlider.create(slider, args);

    slider.noUiSlider.on("update", function (values) {
      amounts.querySelector(".field__input_min").value = values[0];
      amounts.querySelector(".field__input_max").value = values[1];
    });

    slider.noUiSlider.on("change", function (values, handle) {
      const inputs = form.querySelectorAll("input");
      const minInput = Array.from(inputs).find((el) => el.id.includes("GTE"));
      const maxInput = Array.from(inputs).find((el) => el.id.includes("LTE"));
      const changedInput = handle === 0 ? minInput : maxInput;

      form.querySelector("form").dispatchEvent(
        new CustomEvent("input", {
          detail: {
            source: "price-slider",
            selectedInput: changedInput,
            value: values[handle],
          },
          bubbles: true,
        })
      );
    });
  }
}
customElements.define("price-slider", PriceSlider);

class FacetToggleButton extends HTMLElement {
  connectedCallback() {
    const toggle = this.querySelector(
      ".facets-popup-modal--tab-details--toggle.accordion-facets--toggle"
    );
    if (!toggle) return;

    toggle.addEventListener("click", (e) => {
      e.stopPropagation();

      if (this.classList.contains("active")) {
        this.classList.remove("active");
      } else {
        document.querySelectorAll("facet-toggle-button.active").forEach((el) => {
          el.classList.remove("active");
        });

        this.classList.add("active");
      }
    });
  }
}

customElements.define("facet-toggle-button", FacetToggleButton);

/**
 *  @class
 *  @function FacetToggle
 */
if (!customElements.get("facet-toggle")) {
  class FacetToggle extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.setElements();
      this.addEventListener("click", this.onClick.bind(this));
      this.setupObservers();
    }
    disconnectedCallback() {
      this.observer.unobserve(this.wrapper);
    }
    setupObservers() {
      window.addEventListener("scroll", this.onScroll.bind(this));
    }
    setElements() {
      const collectionContainer = this.closest(".collection-container");
      this.drawer = document.getElementById(this.dataset.target);
      this.wrapper = collectionContainer?.querySelector("#product-grid");
      this.form = this.closest("#FacetFiltersForm");
    }
    onClick() {
      this.drawer.show();
    }
    onScroll() {
      if (!this.wrapper) return;

      let total = this.wrapper.offsetTop - window.innerHeight + 90;

      if (window.scrollY < total) {
        this.classList.remove("sticky");
      } else {
        this.classList.add("sticky");
      }
    }
  }

  customElements.define("facet-toggle", FacetToggle);
}
